<div class="border-b border-slate-200 px-5 py-4">
  <div class="flex items-center justify-between">
    <h4 class="text-lg font-semibold text-slate-900" id="modal-basic-title">
      Editar empresa
    </h4>
    <button
      type="button"
      class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="modal().dismiss('Cross click')"
    >
      <i class="bi bi-x"></i>
    </button>
  </div>
</div>
<div class="px-5 py-4">
  <form [formGroup]="formEditar" class="space-y-4">
    <div>
      <label for="nombre" class="mb-1 block text-sm font-medium text-slate-700"
        >Nombre de empresa</label
      >
      <input
        type="text"
        formControlName="nombre"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="nombre"
      />
    </div>

    <div>
      <label
        for="direccion"
        class="mb-1 block text-sm font-medium text-slate-700"
        >Direccion</label
      >
      <input
        type="text"
        formControlName="direccion"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="direccion"
      />
    </div>

    <div class="grid gap-3 md:grid-cols-2">
      <div>
        <label
          for="telefono"
          class="mb-1 block text-sm font-medium text-slate-700"
          >Teléfono</label
        >
        <input
          type="text"
          formControlName="telefono"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          id="telefono"
        />
      </div>
      <div>
        <label
          for="token_sunat"
          class="mb-1 block text-sm font-medium text-slate-700"
          >Token SUNAT</label
        >
        <input
          type="text"
          formControlName="token_sunat"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          id="token_sunat"
        />
      </div>
    </div>

    <div class="grid gap-4 md:grid-cols-4">
      <div>
        <label
          for="maximo_mesas"
          class="mb-1 block text-sm font-medium text-slate-700"
          >Max. mesas</label
        >
        <input
          type="number"
          formControlName="maximo_mesas"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          id="maximo_mesas"
        />
      </div>
      <div>
        <label
          for="maximo_gestion_tiempos"
          class="mb-1 block text-sm font-medium text-slate-700"
          >Max. gestión tiempo</label
        >
        <input
          type="number"
          formControlName="maximo_gestion_tiempos"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          id="maximo_gestion_tiempos"
        />
      </div>
      <div>
        <label
          for="maximo_sucursales"
          class="mb-1 block text-sm font-medium text-slate-700"
          >Max. sucursales</label
        >
        <input
          type="number"
          formControlName="maximo_sucursales"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          id="maximo_sucursales"
        />
      </div>
      <div>
        <label
          for="maximo_telefonos"
          class="mb-1 block text-sm font-medium text-slate-700"
          >Max. teléfonos</label
        >
        <input
          type="number"
          formControlName="maximo_telefonos"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          id="maximo_telefonos"
        />
      </div>
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-slate-700">Sistemas Activos</label>
      <p class="text-xs text-slate-400 mb-2">Activa o desactiva los módulos contratados por la empresa.</p>
      <div class="space-y-1 max-h-48 overflow-y-auto">
        @for (sistema of sistemasDisponibles; track sistema.key) {
          <label class="flex items-center justify-between py-1.5 px-2 rounded hover:bg-slate-50 cursor-pointer transition-colors">
            <span class="text-sm text-slate-600">{{ sistema.label }}</span>
            <button
              type="button"
              role="switch"
              [attr.aria-checked]="isSistemaActivo(sistema.key)"
              (click)="toggleSistema(sistema.key)"
              class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200"
              [class.bg-emerald-600]="isSistemaActivo(sistema.key)"
              [class.bg-gray-300]="!isSistemaActivo(sistema.key)"
            >
              <span
                class="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200"
                [class.translate-x-4]="isSistemaActivo(sistema.key)"
                [class.translate-x-0]="!isSistemaActivo(sistema.key)"
              ></span>
            </button>
          </label>
        }
      </div>

      <div class="mt-3 rounded-lg border border-sky-200 bg-sky-50/60 p-3">
        <label
          for="pidelo_endpoint"
          class="mb-1 block text-sm font-medium text-slate-700"
          >URL pública de Pidelo</label
        >
        <input
          type="url"
          formControlName="pidelo_endpoint"
          id="pidelo_endpoint"
          placeholder="https://pidelo.megatecs.org/mi-empresa"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        />
        @if (formEditar.controls.pidelo_endpoint.invalid) {
          <p class="mt-1 text-xs text-red-600">
            Ingresa una URL válida con el enlace de la carta, por ejemplo
            https://pidelo.megatecs.org/mi-empresa.
          </p>
        } @else {
          <p class="mt-1 text-xs text-slate-500">
            Solo se usa si Pidelo está activo. Debe terminar en el slug de la
            carta, por ejemplo https://pidelo.megatecs.org/mi-empresa.
          </p>
        }
      </div>
    </div>

    <div>
      <label
        for="vencimiento"
        class="mb-1 block text-sm font-medium text-slate-700"
        >Vencimiento</label
      >
      <input
        type="date"
        formControlName="vencimiento"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        id="vencimiento"
      />
    </div>

    <div>
      <div class="mb-2 flex items-center gap-2">
        <label for="anuncios" class="text-sm font-medium text-slate-700"
          >Anuncios</label
        >
        <button
          type="button"
          (click)="addAnuncio('', '')"
          class="rounded-full bg-emerald-600 px-2 py-0.5 text-xs text-white"
        >
          <i class="bi bi-plus"></i>
        </button>
      </div>
      <ul class="space-y-2">
        @for (
          anuncioControl of anunciosFormArray.controls;
          let i = $index;
          track i
        ) {
          <li class="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
            <div
              class="grid gap-2 md:grid-cols-12"
              [formGroup]="$any(anuncioControl)"
            >
              <div class="md:col-span-10 grid gap-2 sm:grid-cols-2">
                <input
                  type="text"
                  formControlName="titulo"
                  class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                  placeholder="Título"
                />
                <input
                  type="text"
                  formControlName="contenido"
                  class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                  placeholder="Contenido"
                />
              </div>
              <div class="md:col-span-2 flex items-center justify-end">
                <button
                  type="button"
                  (click)="delAnuncio(i)"
                  class="rounded-lg bg-red-600 px-2 py-1 text-sm text-white"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  </form>
</div>
<div class="flex justify-end gap-2 border-t border-slate-200 px-5 py-4">
  <button
    type="button"
    class="rounded-lg bg-emerald-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-emerald-500 disabled:cursor-not-allowed disabled:opacity-60"
    (click)="saveChanges()"
    [disabled]="formEditar.invalid"
  >
    Guardar
  </button>
  <button
    type="button"
    class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
    (click)="modal().dismiss('Cross click')"
  >
    Cancelar
  </button>
</div>
